module.exports = __webpack_public_path__ + "img/delete-card-input-number.a3706aca.svg";